import { memo, useRef } from "react";
import { Canvas } from "@react-three/fiber";
import { CameraControls } from "../CameraControls";
import CameraControlsDefault from "camera-controls";
import styles from "./index.module.scss";
import BotModel from "./BotModel";

export const BotThree = memo(function({ pageStatus, currentBot, chatting }: any) {
  const cameraControlsRef = useRef<any>(null);
  const chattingRef = useRef(chatting);

  chattingRef.current = chatting;

  return (
    <div
      className={styles.container}
      style={{
        touchAction: "none"
      }}
    > 
      <Canvas
        dpr={[3, 3]}
        camera={{ position: [0, 0.5, 2.5], fov: 45 }}
        onCreated={(state) => {
          cameraControlsRef.current.setLookAt(0, 0.5, 3, 0, 0.5, 0, true);
        }}
        flat
      >
        <CameraControls
          ref={cameraControlsRef}
          enabled={false}
          minPolarAngle={Math.PI / 2 - Math.PI / 6}
          maxPolarAngle={Math.PI / 2}
          minDistance={1}
          maxDistance={5}
          // 禁用旋转和缩放
          touches={{
            one: CameraControlsDefault.ACTION.NONE,  // 禁用旋转
            two: CameraControlsDefault.ACTION.NONE,  // 禁用缩放
            three: CameraControlsDefault.ACTION.NONE // 禁用三指操作
          }}

        />
        <ambientLight intensity={2} />
        <BotModel pageStatus={pageStatus} currentBot={currentBot} />
      </Canvas>
    </div>
  );
});
